import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import CategoryMiddleware from "../../../store/middleware/categoryMiddleware";
import BrandsMiddleware from "../../../store/middleware/brandsMiddleware";
import PdpReportMiddleware from "../../../store/middleware/pdpReportMiddleware";
import SkusMiddleware from "../../../store/middleware/skusMiddleware";
import RegionsMiddleware from "../../../store/middleware/regionMiddleware";
import CustomSelect from "../../../components/common/select/Select";
import "./PdpReport.styles.scss";
import { Loader } from "../../../components/loader";
import { compare } from '../../../prat_screen/gt/validation/sort';
import CustomToast from '../../../util-functions/customToast.jsx'
import { PdpGraph } from './pdpGraph';
import DATA from '../../../assets/data';

export class PdpReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myBrands: [],
            mySkus: [],
            isLoading: false,
            selectedCategory: '',
            selectedBrand: '',
            selectedSku: [],
            selectedRegion: [],
            selectedChannel: [],
            selectedWeek: '',
            selectedYear: [new Date().getFullYear()],
            initialLoading: true,
            data: [],
            years: [
                { label: new Date().getFullYear() - 1, value: new Date().getFullYear() - 1 },
                { label: new Date().getFullYear(), value: new Date().getFullYear() }
            ],
            weeks: []
        };
    }

    componentDidMount() {
        if (!navigator.onLine) {
            // ToastsStore.error("You are Offline");
            CustomToast('error', 'You are Offline')
            return;
        }
        setTimeout(() => {
            this.handleYearWeeks(this.state.selectedYear);
            this.props.getCategory();
            this.props.getBrands();
            this.props.getSkus();
            this.props.getRegions();
        }, 1000);
    }

    getDataOnComponentMount = () => {
        this.setState({
            selectedCategory: this.props.category[0].guid
        })
        this.props.getPdpReport(
            this.props.category[0].guid,
            this.state.selectedBrand,
            this.state.selectedSku,
            this.state.selectedRegion,
            this.state.selectedChannel,
            this.state.selectedWeek,
            this.state.selectedYear
        )
    };

    handleFilteredSkus = () => {
        const { selectedBrand, selectedSku } = this.state;
        const { skus } = this.props;
        let filteredSkus = [];
        if (selectedBrand) {
            filteredSkus.push(
                ...skus.filter((item) => {
                    return item.Brand === selectedBrand;
                })
            );

            let arr = [];
            if (selectedSku.length) {
                filteredSkus.forEach(item => {
                    if (selectedSku.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedSku: arr });
            }

            this.setState({
                mySkus: filteredSkus,
            });
        }
    };

    handleFilteredBrands = () => {
        const { selectedCategory } = this.state;
        const { brands } = this.props;
        let filteredbrands = [];
        if (selectedCategory) {
            filteredbrands.push(
                ...brands.filter((item) => {
                    return item.Category === selectedCategory;
                })
            );
        }
        this.setState({
            myBrands: filteredbrands,
        },
            () => {
                this.handleFilteredSkus();
            });
    };

    handleChange = (selectedValue) => {
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({
                selectedCategory: '',
                myBrands: [],
                selectedBrand: '',
                selectedSku: [],
                mySkus: [],
            });
        } else {

            this.setState({ selectedCategory: selectedValue.value }, () => {
                this.handleFilteredBrands();
            });
        }
    };

    handleBrandChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({ selectedBrand: selectedValue.value }, () => {
                this.handleFilteredSkus();
            });
        } else {
            this.setState({ selectedBrand: '', selectedSku: [], mySkus: [] });
        }
    };

    handleSkus = (selectedValue) => {
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedSku: [] });
        } else {
            selectedValue.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({ selectedSku: arr });
        }
    };

    handleRegion = (selectedValue) => {
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedRegion: [] });
        } else {
            selectedValue.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({ selectedRegion: arr });
        }
    };

    handleWeekChange = (selectedValue) => {
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedWeek: [] });
        } else {
            selectedValue.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({ selectedWeek: arr });
        }
    }

    handleYearChange = (selectedValue) => {
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedYear: [], selectedWeek: [] });
        } else {
            selectedValue.forEach((element) => {
                arr.push(element.value);
            });
            this.handleYearWeeks(arr);
            this.setState({ selectedYear: arr });
        }
    };

    handleYearWeeks = (value) => {
        let arr = [];
        if (value) {
            value.forEach(year => {
                DATA.WEEK_NO.forEach((item) => {
                    arr.push({
                        value: `${item.value}-${year}`,
                        label: `${item.label}-${year}`,
                    })
                })
            })
        }
        this.setState({
            weeks: arr
        })
    }

    handleSubmit = (e) => {
        this.setState({
            initialLoading: true
        }, () => {
            this.props.getPdpReport(
                this.state.selectedCategory,
                this.state.selectedBrand,
                this.state.selectedSku,
                this.state.selectedRegion,
                this.state.selectedChannel,
                this.state.selectedWeek,
                this.state.selectedYear
            )
        })
    };

    formatData = (value) => {
        try {
            let tempArr = [];
            if (value) {
                tempArr = [...value.Actual, ...value.Estimated];
                tempArr = tempArr.sort(compare).map((item) => item)
            }
            this.setState({
                data: tempArr,
                initialLoading: false
            })
        } catch (error) {
            console.log(error)
        }
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.category !== this.props.category) {
            this.getDataOnComponentMount();
        }

        if (prevProps.brands !== this.props.brands) {
            this.handleFilteredBrands();
        }

        if (prevProps.pdpReport !== this.props.pdpReport && !this.props.isPdpReportLoading) {
            this.formatData(this.props.pdpReport);
        }

        if (this.props.pdpReportHasError) {
            this.setState({
                initialLoading: false
            })
        }
    };

    render() {
        const { initialLoading, data, years, selectedYear, selectedWeek, weeks } = this.state;
        const { category, regions } = this.props;

        return (
            <div className="page-container">
                {initialLoading ? (<Loader flag={true} />)
                    : (
                        <>
                            <div className="heading-and-download-container">
                                <span className="component-heading">PDP Report</span>
                            </div>

                            {/* Filter section start */}
                            <div className="select-container">
                                <div className="filters-container-only">
                                    <CustomSelect.MyCustomSelect
                                        className="single-list-select"
                                        placeholder={"Category"}
                                        options={
                                            category
                                                ? category.sort(compare).map((item) => {
                                                    return {
                                                        value: item.guid,
                                                        label: item.Name,
                                                    };
                                                })
                                                : []
                                        }
                                        onChange={this.handleChange}
                                        value={
                                            category
                                                ? category
                                                    .filter((item) => {
                                                        return this.state.selectedCategory === item.guid
                                                    })
                                                    .map((item) => {
                                                        return {
                                                            value: item.guid,
                                                            label: item.Name,
                                                        };
                                                    })
                                                : []
                                        }
                                    />

                                    <CustomSelect.MyCustomSelect
                                        className="single-list-select"
                                        placeholder={"Brands"}
                                        isClearable
                                        options={
                                            this.state.myBrands.length !== 0
                                                ? this.state.myBrands.sort(compare).map((item) => ({
                                                    value: item.guid,
                                                    label: item.Name,
                                                }))
                                                : []
                                        }
                                        onChange={this.handleBrandChange}
                                        value={this.state.myBrands
                                            .filter((item) => {
                                                return this.state.selectedBrand === item.guid
                                            })
                                            .map((item) => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name,
                                                };
                                            })}
                                    />

                                    <CustomSelect.MyCustomSelect
                                        placeholder={"MSKUs"}
                                        allowSelectAll={true}
                                        isMulti
                                        options={
                                            this.state.mySkus.length !== 0
                                                ? this.state.mySkus.sort(compare).map((item) => ({
                                                    value: item.guid,
                                                    label: item.Description,
                                                }))
                                                : []
                                        }
                                        onChange={this.handleSkus}
                                        value={this.state.mySkus
                                            .filter((item) => {
                                                return this.state.selectedSku.includes(item.guid);
                                            })
                                            .map((item) => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Description,
                                                };
                                            })}
                                    />

                                    <CustomSelect.MyCustomSelect
                                        placeholder={"Region"}
                                        allowSelectAll={true}
                                        isMulti
                                        options={
                                            regions
                                                ? regions.sort(compare).map((item) => ({
                                                    value: item.guid,
                                                    label: item.Name.toUpperCase(),
                                                }))
                                                : []
                                        }
                                        onChange={this.handleRegion}
                                        value={
                                            regions
                                                ? regions
                                                    .filter((item) => {
                                                        return this.state.selectedRegion.includes(
                                                            item.guid
                                                        );
                                                    })
                                                    .map((item) => {
                                                        return {
                                                            value: item.guid,
                                                            label: item.Name.toUpperCase(),
                                                        };
                                                    })
                                                : null
                                        }
                                    />

                                    <CustomSelect.MyCustomSelect
                                        placeholder={"Channel"}
                                        isDisabled={true}
                                        allowSelectAll={true}
                                        isMulti
                                        options={[]}
                                        onChange={() => { }}
                                        value={[]}
                                    />

                                    <CustomSelect.MyCustomSelect
                                        className="single-list-select"
                                        allowSelectAll={true}
                                        isMulti
                                        placeholder={"Year"}
                                        options={years}
                                        onChange={this.handleYearChange}
                                        value={selectedYear && years
                                            .filter((item) => {
                                                return selectedYear.includes(item.value)
                                            })
                                            .map((item) => item)}
                                    />

                                    <CustomSelect.MyCustomSelect
                                        className="single-list-select"
                                        allowSelectAll={true}
                                        isMulti
                                        placeholder={"Week"}
                                        options={weeks}
                                        onChange={this.handleWeekChange}
                                        value={
                                            selectedWeek && weeks
                                                .filter((item) => {
                                                    return selectedWeek.includes(item.value)
                                                })
                                                .map((item) => item)
                                        }
                                    />

                                </div>

                                <Button
                                    style={{ marginBottom: 10 }}
                                    variant="outlined"
                                    className="submit-btn"
                                    onClick={(e) => this.handleSubmit(e)}
                                >
                                    SUBMIT
                                </Button>

                            </div>
                            {/* Filter section end */}

                            <div className='pdp-chart-container'>
                                <div className='pdp-chart-heading'>PDP Graph</div>
                                <PdpGraph
                                    data={data}
                                />
                            </div>
                        </>
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.CategoryReducer.isLoading,
        category: state.CategoryReducer.category,
        brands: state.BrandsReducer.brands,
        skus: state.SkusReducer.skus,
        regions: state.RegionReducer.regions,
        isPdpReportLoading: state.PdpReportReducer.isPdpReportLoading,
        pdpReportHasError: state.PdpReportReducer.pdpReportHasError,
        pdpReport: state.PdpReportReducer.pdpReport
    };
};

const mapDispatchToprops = (dispatch) => {
    return {
        getCategory: () => {
            return dispatch(CategoryMiddleware.getCategory());
        },
        getBrands: () => {
            return dispatch(BrandsMiddleware.getBrands());
        },
        getSkus: () => {
            return dispatch(SkusMiddleware.getSkus());
        },
        getRegions: () => {
            return dispatch(RegionsMiddleware.getRegions());
        },
        getPdpReport: (
            selectedCategory,
            selectedBrand,
            selectedSku,
            selectedRegion,
            selectedChannel,
            selectedWeek,
            selectedYear
        ) => {
            return dispatch(PdpReportMiddleware.getPdpReport(
                selectedCategory,
                selectedBrand,
                selectedSku,
                selectedRegion,
                selectedChannel,
                selectedWeek,
                selectedYear
            ))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToprops)(PdpReport);
